export default "__VITE_ASSET__ClpecHGN__"